// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Enumerations/TrackingSearchBy.proto (package time_tracking.enumerations, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import { file_Options_EnumValueOptions } from "../Options/EnumValueOptions_pb";

/**
 * Describes the file Enumerations/TrackingSearchBy.proto.
 */
export const file_Enumerations_TrackingSearchBy: GenFile = /*@__PURE__*/
  fileDesc("CiNFbnVtZXJhdGlvbnMvVHJhY2tpbmdTZWFyY2hCeS5wcm90bxIadGltZV90cmFja2luZy5lbnVtZXJhdGlvbnMq4QIKEFRyYWNraW5nU2VhcmNoQnkSKAocVFJBQ0tJTkdfU0VBUkNIX0JZX1RFTkFOVF9JRBAAGgbKx80PAQMSKAocVFJBQ0tJTkdfU0VBUkNIX0JZX1VTRVJfTkFNRRABGgbKx80PAQUSMQolVFJBQ0tJTkdfU0VBUkNIX0JZX1RSQUNLSU5HX0tJTkRfTkFNRRACGgbKx80PAQcSKwofVFJBQ0tJTkdfU0VBUkNIX0JZX1BST0pFQ1RfTkFNRRADGgbKx80PAQkSMwonVFJBQ0tJTkdfU0VBUkNIX0JZX0lOVEVSTkFMX0RFU0NSSVBUSU9OEAQaBsrHzQ8BDBIxCiVUUkFDS0lOR19TRUFSQ0hfQllfUFVCTElDX0RFU0NSSVBUSU9OEAUaBsrHzQ8BDRIxCiVUUkFDS0lOR19TRUFSQ0hfQllfRVhURVJOQUxfUkVGRVJFTkNFEAYaBsrHzQ8BEEIoqgIlTW9naS5UaW1lVHJhY2tpbmcuQ29tbW9uLkVudW1lcmF0aW9uc2IGcHJvdG8z", [file_Options_EnumValueOptions]);

/**
 * Determines which columns of a tracking can be used for text search.
 *
 * @generated from enum time_tracking.enumerations.TrackingSearchBy
 */
export enum TrackingSearchBy {
  /**
   * Search through the tenant id of a tracking.
   *
   * @generated from enum value: TRACKING_SEARCH_BY_TENANT_ID = 0;
   */
  TENANT_ID = 0,

  /**
   * Search through the user name of a tracking.
   *
   * @generated from enum value: TRACKING_SEARCH_BY_USER_NAME = 1;
   */
  USER_NAME = 1,

  /**
   * Search through the tracking kind name (billable, etc.) of a tracking.
   *
   * @generated from enum value: TRACKING_SEARCH_BY_TRACKING_KIND_NAME = 2;
   */
  TRACKING_KIND_NAME = 2,

  /**
   * Search through the project name of a tracking.
   *
   * @generated from enum value: TRACKING_SEARCH_BY_PROJECT_NAME = 3;
   */
  PROJECT_NAME = 3,

  /**
   * Search through the internal description of a tracking.
   *
   * @generated from enum value: TRACKING_SEARCH_BY_INTERNAL_DESCRIPTION = 4;
   */
  INTERNAL_DESCRIPTION = 4,

  /**
   * Search through the public description of a tracking.
   *
   * @generated from enum value: TRACKING_SEARCH_BY_PUBLIC_DESCRIPTION = 5;
   */
  PUBLIC_DESCRIPTION = 5,

  /**
   * Search through the external reference text of a tracking.
   *
   * @generated from enum value: TRACKING_SEARCH_BY_EXTERNAL_REFERENCE = 6;
   */
  EXTERNAL_REFERENCE = 6,
}

/**
 * Describes the enum time_tracking.enumerations.TrackingSearchBy.
 */
export const TrackingSearchBySchema: GenEnum<TrackingSearchBy> = /*@__PURE__*/
  enumDesc(file_Enumerations_TrackingSearchBy, 0);

